import React from 'react';
import PropTypes from 'prop-types';
import { mapValues } from 'lodash';
import { createUniversalPortal } from 'react-portal-universal';
import ImageZoom from '../ImageZoom';
import Title from '../Title';
import HeaderWrapper from '../HeaderWrapper';
import CodeBlock from '../CodeBlock';

const portalComponents = {
  Title,
  HeaderWrapper,
  ImageZoom,
  CodeBlock
};

const PortalsRenderer = ({ portals, meta }) => (
  portals.map(({ component, containerID, props }) => {
    const Component = portalComponents[component];
    const propsValues = mapValues(props, prop => prop.value);
    return createUniversalPortal(
      <Component {...propsValues} meta={meta} />,
      `#${containerID}`
    );
  })
);


PortalsRenderer.propTypes = {
  portals: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired
};

export default PortalsRenderer;
